import { render } from "./ModelDownloadLinkDialog.vue?vue&type=template&id=ec5e0d46"
import script from "./ModelDownloadLinkDialog.vue?vue&type=script&lang=js"
export * from "./ModelDownloadLinkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__